<template>
  <div style="margin: 20px;">
    <div style="float: left;margin-bottom: 40px">
      生产溯源
    </div>
    <div>
      <table class="table table-bordered" style="font-size: 14px;max-height: 700px;overflow-y: scroll;">
        <thead>
          <tr>
            <th>时间</th>
            <th>操作人</th>
            <th>状态</th>
          </tr>
        </thead>
        <tbody v-for="item in processInfo">
          <tr>
            <td>{{ item.date }}</td>
            <td>{{ item.worker }}</td>
            <td>{{ item.name }}</td>
          </tr>
        </tbody>
      </table>
      <div style="float: left;margin-bottom: 40px" v-if="install.length > 0">
        实施现场
      </div>
      <div style="margin:30px 0 100px 0" v-if="install.length > 0">
        <table border="1" width="100%" height="100px" align="center" bordercolor="black" cellspacing="5"
          cellpadding="5">
          <!-- 2.创建行 -->
          <tr style="border: 1px solid black;">
            <th style="padding:15px 0 15px 0">施工图</th>
            <th>安装人员</th>
            <th>完成时间</th>
          </tr>
          <tr v-for="item in install">
            <td>
              <img :src="item.img" width="120" @click="goPic(item.img)" v-if="item.img !== ''" />
              <span v-else>待上传</span>
            </td>
            <td>{{ item.worker }}</td>
            <td>{{ item.completion_time }}</td>
          </tr>
        </table>
      </div>

      <div style="margin-top: 40px;padding-bottom: 40px" v-if="repairInfo.length > 0">
        <div style="float: left;margin-bottom: 40px">维保记录</div>
        <table class="table table-bordered" style="font-size: 14px;max-height: 700px;overflow-y: scroll;">
          <thead>
            <tr>
              <th style="width: 25%">提交时间</th>
              <th style="width: 25%">维保内容</th>
              <th style="width: 18%">状态</th>
              <th style="width: 25%">完成时间</th>
            </tr>
          </thead>
          <tbody v-for="item in repairInfo">
            <tr>
              <td>{{ item.created_at }}</td>
              <td>{{ item.describe }}</td>
              <td>
                <span v-if="item.status === 1">待处理</span>
                <span v-else-if="item.status === 2">跟进</span>
                <span v-else-if="item.status === 3">完成</span>
                <span v-else-if="item.status === 9">作废</span>
              </td>
              <td>{{ item.complete_time }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!--  <van-dialog v-model="show" >-->
    <!--    <img :src="currentPic"  :style="style"/>-->
    <!--  </van-dialog>-->
    <van-image-preview v-model="show" :images="currentPic">
    </van-image-preview>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "hl-product",
  data() {
    return {
      processInfo: [],
      install: [],
      show: false,
      currentPic: [],
      repairInfo: []
    }
  },
  methods: {
    goPic(pic) {
      this.show = true;
      this.currentPic = [pic];
    }
  },
  mounted() {
    const code = this.$route.query.id || this.$route.query.code || '';
    if (code) {
      sessionStorage.setItem('id', code);
      this.axios.get(`/qrcode/source_by_code?code=${code}`).then(res => {
        this.processInfo = res.data.data.process;
        this.install = res.data.data.install;
        this.repairInfo = res.data.data.after_sales || [];
      })
      // axios({
      //   url: `https://gcds.thinkerx.com/api/qrcode/source?id=${this.$route.query.id}`,
      //   methods: 'get',
      // }).then(res => {
      //   this.processInfo = res.data.data.process;
      //   this.install = res.data.data.install;
      //   this.repairInfo = res.data.data.after_sales || [];
      // })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/hl-product.vue